var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "title_wrapper" }, [
    _c("div", { staticClass: "title" }, [_vm._t("title")], 2),
    _c("div", { staticClass: "sub-title" }, [_vm._t("sub_title")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }